import React from "react";

import {
  TextField as MuiTextField,
  TextFieldProps,
  styled,
} from "@mui/material";
import { spacing } from "@mui/system";
import { SpacingProps } from "@mui/system";

type Props = TextFieldProps &
  SpacingProps & { minWidth?: string; error?: boolean; errorLabel?: string };
const defaultMinWidth = "220px";

const TextFieldRaw = styled(styled(MuiTextField, {
  shouldForwardProp: (prop) => prop !== "minWidth",
})<Props>`
  min-width: ${({ minWidth }) => (minWidth ? minWidth : defaultMinWidth)};
`)(spacing);

const TextField: React.FC<Props> = (props) => {
  const { error, errorLabel, ...propsOpt } = props;
  return (
    <TextFieldRaw
      {...propsOpt}
      error={error}
      helperText={(error && errorLabel) || ""}
      variant="standard"
      value={propsOpt.value || ""}
    />
  );
};

export default TextField;
